import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { JAlertComponent } from '@jabil/foundation';

@Component({
	selector: 'p-root',
	imports: [RouterOutlet, JAlertComponent],
	templateUrl: './app.html'
})
export class App {}
